module.exports = __webpack_public_path__ + "media/audio1.04532779.mp3";